import { render, staticRenderFns } from "./costCenter.vue?vue&type=template&id=54db2fc2&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./costCenter.vue?vue&type=style&index=0&id=54db2fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db2fc2",
  null
  
)

export default component.exports